(function () {
  if (window.is_member_login_js_inited) return;
  window.is_member_login_js_inited = true;

  try {
    // document.addEventListener("DOMContentLoaded", function () {

    const currentPath = window.location.pathname;
    const domain = "https://aws-mall.ogl-dragon.com";
    // 来自站内，且要去到个人中心
    const scenario_1 = ["site_icon", "site_membership_program"];

    const scenario_2 = [
      "email",
      "email_subwelcome",
      "email_paid",
      "email_delivered",
      "email_nps",
    ];
    const isLogin = window.member_is_login;
    const isMobile = window.innerWidth < 768;

    let urlParams = new URLSearchParams(window.location.search);

    const rf = urlParams.get("rf");
    const utm_source = urlParams.get("utm_source");
    const registerSuccess = urlParams.get("registerSuccess");
    const loginSuccess = urlParams.get("loginSuccess");
    const return_url = urlParams.get("return_url");
    const visitType =
      location.pathname.split("/").filter(Boolean).pop() || "login";

    let targetTab;

    // 点击联登按钮的统计
    document.addEventListener("click", (e) => {
      const target = e.target;
      const loginBtn = target.closest(".h_google_button");
      const fbLoginBtn = target.closest(".h_facebook_button");

      if (loginBtn) {
        sendData({ name: `member-google-login` });
        return;
      }

      if (fbLoginBtn) {
        sendData({ name: `member-facebook-login` });
        return;
      }
    });

    // 保存 rf 和 utm_source
    if (rf) localStorage.setItem("member-rf", rf);
    if (utm_source) localStorage.setItem("member-utm_source", utm_source);

    // 处理页面右上角的“个人中心”图标的点击  ------- start ------->
    // mobile 端, 点击 banner
    $(`.account-icon-J, a[href*="rf=site_"]`).on("click", (e) => {
      // 如果用户已经登录，走原来的逻辑
      if (isLogin) return;

      // 未登录，通过 js 来控制
      e.preventDefault();

      const target = e.target;
      const href =
        $(target).closest(".account-icon-J").attr("href") ||
        $(target).closest("[href]").attr("href");
      const queryString = href.split("?")[1];
      const _urlParams = new URLSearchParams(queryString);
      const _rf = _urlParams.get("rf");
      const _utm_source = _urlParams.get("utm_source");

      if (_rf) localStorage.setItem("member-rf", _rf);
      if (_utm_source) localStorage.setItem("member-utm_source", _utm_source);

      // 如果用户未登录：能识别，去登录页；不能识别，去注册页
      const isLogined = localStorage.getItem("member-logined");

      // 带上 rf 或 utm_source 去登录/注册页
      let url = "/account/register";
      if (isLogined) url = "/account/login";
      location.href = url + `?${_urlParams.toString()}`;
    });
    // pc 端
    $('a[href="/account"][data-drawer-options]').on("click", () => {
      // 如果用户已经登录，走原来的逻辑
      if (isLogin) return;

      // 如果用户未登录：能识别，去登录页；不能识别，去注册页
      const isLogined = localStorage.getItem("member-logined");
      let _targetTab = "register";
      if (isLogined) _targetTab = "login";

      targetTab = _targetTab;

      // Tab切换功能
      const $tabItems = $(".t4s-tab-item");
      const $tabPanels = $(".t4s-tab-panel");
      // 移除所有 class
      $tabItems.removeClass("active");
      $tabPanels.removeClass("active");
      // 高亮 tab
      document
        .querySelectorAll(`.t4s-tab-item[data-target="${_targetTab}"]`)
        .forEach((element) => {
          element.classList.add("active");
        });
      // 显示 tab 对应的内容
      document.querySelectorAll(`#tab-${_targetTab}`).forEach((element) => {
        element.classList.add("active");
      });
    });
    // 处理页面右上角的“个人中心”图标的点击  ------- end ------->

    // 采集 登录/注册 失败的数据  ------- start ------->
    const errorMsg = $(".form-error").eq(0).text();
    const errorType = visitType;
    if (errorMsg && errorType) {
      sendData({
        name: `member-${errorType}-failed`,
        message: errorMsg,
      });
    }
    // 采集 登录/注册 失败的数据  ------- end ------->

    const isInLoginPage = ["/account/register", "/account/login"].includes(
      location.pathname
    );

    // 如果已经登录，且访问的是登录/注册页面，跳转到相应的地方
    if (isLogin && isInLoginPage) {
      location.href = "/account";
      return;
    }

    targetTab = visitType;

    // 侧边栏（登录/注册）出现的时候要发送埋点  ---------- start ----------->
    // 目标元素的选择器
    const targetElement = document.getElementById("t4s-login-sidebar");

    console.log("===>>> targetElement:", targetElement);

    if (targetElement) {
      // 创建 MutationObserver 实例
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          // 检查是否是 aria-hidden 属性发生变化
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "aria-hidden"
          ) {
            const currentValue = targetElement.getAttribute("aria-hidden");
            if (currentValue === "false")
              sendData({
                name: `member-login-sidebar-show`,
                currentTab: targetTab,
              });
          }
        });
      });

      // 配置观察选项
      const config = {
        attributes: true, // 观察属性变化
        attributeFilter: ["aria-hidden"], // 只观察 aria-hidden 属性
        subtree: false, // 不观察子元素
      };

      // 开始观察目标元素
      observer.observe(targetElement, config);

      // 初始检查（可选）
      const initialValue = targetElement.getAttribute("aria-hidden");
      console.log("Initial aria-hidden value:", initialValue);
    } else {
      console.warn('Element with ID "t4s-login-sidebar" not found');
    }
    // 侧边栏（登录/注册）出现的时候要发送埋点  ---------- end ----------->

    const getT = function () {
      return fetch(`${domain}/api/v1/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // 告诉服务器发送的是 JSON
        },
        body: JSON.stringify({
          user_name: "shopify",
          user_password: "MJy7ayjCe6KVv2IESnn9",
        }),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error("error:", error);
        });
    };

    // 推送数据给服务端
    const pushData = function (data, t) {
      fetch(
        `${domain}/api/v1/customer-center/save-shopify-customer-subscription`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: t,
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => response.json())
        .catch((error) => {
          // alert("error:", error);
        });
    };

    // 根据路径自动激活对应标签
    function activateTabBasedOnPath() {
      const tabItems = document.querySelectorAll(".t4s-tab-item");
      const tabPanels = document.querySelectorAll(".t4s-tab-panel");

      // 移除所有active类
      tabItems.forEach((tab) => tab.classList.remove("active"));
      tabPanels.forEach((panel) => panel.classList.remove("active"));

      // 找到并激活对应的标签和面板
      const activeTab = document.querySelector(
        `.t4s-tab-item[data-target="${targetTab}"]`
      );
      if (activeTab) {
        activeTab.classList.add("active");
      } else {
        // alert("activeTab is not exist.");
      }

      const activePanel = document.getElementById(`tab-${targetTab}`);
      if (activePanel) {
        activePanel.classList.add("active");
      } else {
        // alert("activePanel is not exist.");
      }
    }

    // 页面加载时激活对应标签
    activateTabBasedOnPath();

    // Tab切换功能
    $(document).on("click", ".t4s-tab-item", function () {
      const $item = $(this);
      const target = $item.attr("data-target");
      const isInSidebar = $("#t4s-login-sidebar").attr("aria-hidden");
      const $parentBox = $item.closest(".login-or-register");

      sendData({ name: `member-click-tab-${target}` });

      // 初始化表单
      fillBackData(target);

      // 记录一下当前 tab
      localStorage.setItem("account-current-tab", target);

      // 在 pc 的 sidebar 中，才用 js 切换，否则，直接跳转页面
      if (!isMobile && isInSidebar) {
        // 移除所有active类
        $parentBox.find(".t4s-tab-item").removeClass("active");
        $parentBox.find(".t4s-tab-panel").removeClass("active");

        // 添加active类到当前tab
        $item.addClass("active");

        // 显示对应内容
        $parentBox.find(`#tab-${target}`).addClass("active");
      } else {
        // 如果要跳转的页面和当前页相同，不做任何操作
        if (target === targetTab) return;
        location.href = `/account/${target}`;
      }
    });

    // 忘记密码和回到登录功能
    const forgotPasswordLinks = document.querySelectorAll(
      ".t4s-recover-toggle"
    );
    const loginForm = document.getElementById("login");
    const recoverForm = document.getElementById("recover");

    if (forgotPasswordLinks.length > 0) {
      forgotPasswordLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          if (this.getAttribute("href") === "#login") {
            // 回到登录页面
            recoverForm.style.display = "none";
            loginForm.style.display = "block";
          } else {
            // 前往找回密码页面
            loginForm.style.display = "none";
            recoverForm.style.display = "block";
            // 发送重置密码的埋点
            sendData({ name: `member-reset-password` });
          }
        });
      });
    }

    // 页面初始化的时候，判断一次
    const hash = window.location.hash;
    if (hash === "#recover") {
      // 前往找回密码页面
      loginForm.style.display = "none";
      recoverForm.style.display = "block";
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 0);

      // 发送重置密码的埋点
      sendData({ name: `member-reset-password` });

      // e.preventDefault();
    }

    // 使用jQuery添加表单校验功能
    function validateInput($input) {
      // 清除之前的错误消息
      const $parentField = $input.closest(".t4s_field");
      $parentField.find(".form-error").remove();
      $input.removeClass("input-error");

      // 检查是否必填
      const requiredMessage = $input.data("requiredMessage");
      if (requiredMessage && $input.val().trim() === "") {
        showError($input, requiredMessage);
        return false;
      }

      // 检查是否符合规则
      const invalidMessage = $input.data("invalidMessage");
      const rulesAttr = $input.data("rules");

      if ($input.val().trim() !== "" && rulesAttr && invalidMessage) {
        try {
          const rules =
            typeof rulesAttr === "string" ? JSON.parse(rulesAttr) : rulesAttr;
          for (let rule of rules) {
            const regex = new RegExp(rule);
            if (!regex.test($input.val().trim())) {
              showError($input, invalidMessage);
              return false;
            }
          }
        } catch (e) {
          // alert("无法解析验证规则:", e);
        }
      }

      return true;
    }

    // 添加校验隐私条款的函数
    function validatePrivacyPolicy($form) {
      // 查找隐私条款复选框
      const $privacyCheckbox = $form.find(
        'input[name="customer\\[agree_privacy\\]"]'
      );

      // 如果找到隐私条款复选框但未勾选
      if ($privacyCheckbox.length > 0 && !$privacyCheckbox.is(":checked")) {
        // 移除之前的错误消息
        const $checkboxContainer = $privacyCheckbox.parent();
        $checkboxContainer.next(".form-error").remove();

        // 从data属性获取错误消息，如果没有则使用默认消息
        const errorMessage = $privacyCheckbox.data("uncheckedMessage");

        // 添加错误消息
        $("<div>")
          .addClass("form-error")
          .text(errorMessage)
          .css({
            color: "var(--t4s-error-color)",
            "font-size": "12px",
            "line-height": "12px",
            margin: "-2px 0px 10px 25px",
          })
          .insertAfter($checkboxContainer);

        return false;
      }

      return true;
    }

    function showError($input, message) {
      const $parentField = $input.closest(".t4s_field");
      $("<div>")
        .addClass("form-error")
        .text(message)
        .css({
          color: "var(--t4s-error-color)",
          "font-size": "12px",
          "line-height": "12px",
          "margin-top": "5px",
        })
        .appendTo($parentField);

      $input.addClass("input-error");
    }

    function sendData(params) {
      if (Shopify) {
        Shopify.analytics.publish("member-datac", {
          ...params,
          customerId: window.customer_id || "",
          platform: !isMobile ? "pc" : "mobile",
        });
      } else {
        console.error("===>>> sendData error");
      }
    }

    // 使用jQuery事件委托监听所有表单的input blur事件
    $(".login-or-register")
      .find("form")
      .each(function () {
        const $form = $(this);

        // 为所有input添加blur事件
        $form.on(
          "blur",
          'input:not([type="hidden"]):not([type="submit"]):not([type="checkbox"])',
          function () {
            validateInput($(this));
          }
        );

        // 表单提交验证
        $form.find(".j-submitBtn").on("click", function (e) {
          // e.preventDefault();
          try {
            let isValid = true;
            const _email = $form.find('[name="customer\\[email\\]"]').val();
            const $inputs = $form.find(
              'input:not([type="hidden"]):not([type="submit"]):not([type="checkbox"])'
            );

            $inputs.each(function () {
              if (!validateInput($(this))) {
                isValid = false;
              }
            });

            // 点击“提交”按钮，上报点击
            sendData({
              name: `member-form-submit__${targetTab}`,
              email: _email || "",
            });

            // 验证隐私条款是否勾选
            // if (!validatePrivacyPolicy($form)) {
            //   isValid = false;
            // }

            if (!isValid) {
              e.preventDefault();
              // 滚动到第一个错误输入
              const $firstError = $form
                .find(".input-error, .form-error")
                .first();
              if ($firstError.length) {
                $("body").animate(
                  {
                    scrollTop: $firstError.offset().top - 100,
                  },
                  300
                );
                // 如果错误元素是输入框，则聚焦
                if ($firstError.is("input")) {
                  $firstError.focus();
                }
              }

              // 上报：表单校验失败
              sendData({
                name: `member-form-submit-invalid-info__${targetTab}`,
              });

              return;
            }

            // 表单验证成功，如果用户勾选了订阅，保存订阅信息
            if (
              $('[name="customer\\[accepts_marketing\\]"]').val() === "true" &&
              _email
            ) {
              getT().then(function (res) {
                const tInfo = res || {};
                const t = (tInfo.data || {}).token;

                pushData(
                  {
                    email: _email,
                    status:
                      $('[name="customer\\[accepts_marketing\\]"]').val() ===
                      "true"
                        ? 1
                        : 2,
                  },
                  t
                );
              });
            } else {
              sendData({
                name: "member-subscription-failed",
                email: _email,
              });
            }
          } catch (e) {
            // alert(">>>>> pushData error:", e);
          }
          // e.preventDefault();
        });
      });

    // 显示/隐藏密码
    $(document).on("click", ".hide-or-show-password", function () {
      const $box = $(this);
      $box
        .prev("input")
        .attr("type", $box.hasClass("show") ? "text" : "password");
      $box.toggleClass("show");
    });

    const key = "member-login-or-register-info";

    // 辅助方法
    function getFormData() {
      try {
        const formDataStr =
          localStorage.getItem(key) || '{"login": {}, "register": {}}';
        return JSON.parse(formDataStr);
      } catch (e) {
        return {};
      }
    }

    function setFormData(data) {
      localStorage.setItem(key, JSON.stringify(data));
    }

    // 备注：清除掉方法在 account、membercenter 页面

    // 保存登录/注册表单的值
    $("#login")
      .find('input[name*="customer"]')
      .not('[type="checkbox"]')
      .not('[type="password"]')
      .add(
        $("#register")
          .find('input[name*="customer"]')
          .not('[type="checkbox"]')
          .not('[type="password"]')
      )
      .on("input", function (e) {
        const $formItem = $(this);
        const $form = $formItem.parents("form");
        const formItemName = $formItem.attr("name");
        const id = $form.parent().attr("id");
        const formData = getFormData();
        const val = e.target.value;

        if ($formItem.attr("type") === "password") return;

        if (formData && id && formItemName && formData[id])
          formData[id][formItemName] = val;

        setFormData(formData);

        console.log("val:", e.target.value);
        console.log("id:", id);
        console.log("formItemName:", formItemName);
        console.log("formData:", formData);
      });

    // 根据 localStorage 中的表单数据初始化表单（回填数据）
    function fillBackData(id) {
      const currentFormDataInLS = getFormData()[id];
      $(`#${id}`)
        .find('input[name*="customer"]')
        .not('[type="checkbox"]')
        .each(function (_index, _value) {
          const $item = $(this);
          const name = $item.attr("name");
          const val = currentFormDataInLS[name];

          val && $item.val(val);
          console.log("index:", _index);
          console.log("value:", _value);
        });
    }

    // 回填表单数据
    fillBackData(targetTab);

    // });
  } catch (e) {
    console.log("=====>>> e:", e);
  }
})();
